import React from "react";
import { DatePicker as AntDatePicker, Form } from "antd";
import Props from "./Props";

const DatePicker: React.FC<Props> = ({ name, config, ...rest }) => {
  return (
    <Form.Item
      name={name}
      label={config.label}
      rules={config.validationRules}
      labelCol={{ span: 24 }}
      {...(config.extra || {})}
      {...rest}
    >
      <AntDatePicker
        placeholder={config.placeholder}
        format={config.format}
        showTime={config.showTime}
      />
    </Form.Item>
  );
};

export default DatePicker;
